module.exports = __webpack_public_path__ + "59499ad62aad702bd62695ee91480667.svg";